import s from './Checkbox.module.scss';
import React, { useId, ReactNode } from 'react';
import classNames from 'classnames';
import CheckTickIcon from '@/shared/assets/icons/check-tick.svg';

export interface CheckboxProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'onChange' | 'value' | 'size'
> {
  className?: string;
  label?: ReactNode;
  labelPosition?: 'left' | 'right';
  justify?: 'start' | 'space-between';
  onChange?: (checked: boolean) => void;
  variant?: 'default' | 'radioLike';
  color?: 'default' | 'green';
  size?: 'default' | 's';
}

export const Checkbox = (props: CheckboxProps) => {
  const {
    className,
    checked,
    onChange,
    label,
    labelPosition = 'right',
    justify = 'start',
    variant = 'default',
    color = 'default',
    size = 'default',
    disabled,
    ...rest
  } = props;
  const id = useId();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.checked);
  };

  const mods = {
    [s.checked]: checked,
    [s.disabled]: disabled,
  };

  return (
    <div
      className={classNames(
        s.Input,
        mods,
        className,
        variant === 'radioLike' && s.radioLike,
        s[`position-${labelPosition}`],
        s[`justify-${justify}`],
        s[`color-${color}`],
        s[`size-${size}`],
      )}
    >
      <label htmlFor={id} className={s.wrapper}>
        {labelPosition === 'left' && label && <span className={s.labelText}>{label}</span>}
        <div className={s.checkbox}>{checked && <CheckTickIcon className={s.icon} />}</div>
        {labelPosition === 'right' && label && <span className={s.labelText}>{label}</span>}
      </label>
      <input
        className={s.input}
        type="checkbox"
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={handleInputChange}
        {...rest}
      />
    </div>
  );
};
